'use strict';

class EmailChange {
  constructor(userService, I18N, Notification) {
    this.userService = userService;
    this.I18N = I18N;
    this.Notification = Notification;
  }

  $onInit() {
    this.email = null;
    this.verify = null;

    this.load();
  }

  load() {
    this.userService.get()
      .then((resp) => {
        this.email = resp.data.userName;
      });
  }

  update() {
    if (this.email && this.verify && this.email === this.verify) {
      swal({
        title: 'Er du sikker?',
        type: 'warning',
        confirmButtonColor: '#004b8d',
        confirmButtonText: 'Bekreft',
        showCancelButton: true,
        cancelButtonText: 'Avbryt'
      }, () => {
        this.userService.updateEmail(this.email)
          .then(() => {
            this.load();
            this.Notification.success(this.I18N.general.saved);
          })
          .catch((err) => this.Notification.error(err.data.endUserMessage));
      }, this);
    }
  }
}

EmailChange.$inject = ['userService', 'I18N', 'Notification'];

const emailChange = {
  controller: EmailChange,
  template: `
    <fieldset ng-form name="emailChangeForm">
      <h3 class="subheader">Endre brukernavn <span data-balloon-length="large" data-balloon="E-postadressen du logger på med. Kontakt e-postadresse og e-postadressen på regningene dine kan endres ved å gå til KONTO"><i class="fa fa-question-circle"></i></span></h3>

      <div>
        <label for="email">Brukernavn (e-postadresse)</label>
        <input type="email" id="email" name="email" autocomplete="email" ng-model="$ctrl.email" maxlength="64" placeholder="ola@nordmann.no" required>
      </div>

      <hr>

      <div>
        <label for="current">Gjenta brukernavn</label>
        <input type="email" id="verify" name="verify" ng-model="$ctrl.verify" maxlength="64" placeholder="ola@nordmann.no" required>
      </div>

      <button class="button" ng-click="$ctrl.update()" ng-disabled="emailChangeForm.$invalid || $ctrl.verify !== $ctrl.email">Lagre</button>
    </fieldset>
  `
};

angular
  .module('SendRegning')
  .component('emailChange', emailChange);
